export default {"src":"/_next/static/media/close-white.77712201.svg","height":17,"width":17};